// Helpers puros de la vista de torneo del club (acotar a sus categorias +
// posiciones por grupo). Sin red.

// Categorias donde el club tiene equipos inscritos en el torneo (lista blanca).
// Filtra por club_org_id cuando se pasa (defensa: no depender solo del RLS).
export const categoriasDelClub = (inscripciones = [], clubOrgId = null) => {
  const map = new Map()
  ;(inscripciones || []).forEach((i) => {
    if (clubOrgId && i.club_org_id !== clubOrgId) return
    const cat = i.categorias || null
    const id = i.categoria_id || cat?.id || null
    if (id && !map.has(id)) map.set(id, cat?.nombre || i.categoria_nombre || 'Categoria')
  })
  return Array.from(map, ([id, nombre]) => ({ id, nombre }))
}

// ¿Las filas de posiciones vienen separadas por grupo? (torneo con fase de grupos).
export const tienePorGrupo = (rows = []) =>
  (rows || []).some((r) => r.grupo_torneo != null && r.grupo_torneo !== '')

// Agrupa filas de get_tabla_grupos por grupo_torneo, conservando orden de aparicion.
export const agruparPosicionesPorGrupo = (rows = []) => {
  const map = new Map()
  ;(rows || []).forEach((r) => {
    const g = r.grupo_torneo || null
    const key = g || '__sin__'
    if (!map.has(key)) map.set(key, { grupo: g, filas: [] })
    map.get(key).filas.push(r)
  })
  return Array.from(map.values())
}
